/**
 * PassSlot — a WalletPass scaled into a fixed box (the mockup's `.pslot`).
 * ─────────────────────────────────────────────────────────────────────
 *   <PassSlot card={ME_DARK} photoUrl={PHOTO_URL} scale={0.92} scaleT={0.84} clip={56} />
 * scale / scaleT (≤980px) / scaleM (≤600px) pick the size; `fit` also caps it to the
 * parent's content width; `clip` crops the pass to its first N px (wallet stack).
 * A logo on a coloured pass is inverted to white (`.pslot.inv`), like the mockup.
 */
import React, { useLayoutEffect, useRef, useState } from 'react';
import WalletPass from '../../components/WalletPass.jsx';
import useBp from './useBp.js';

export default function PassSlot({ card, logoUrl, photoUrl, scale = 1, scaleT, scaleM, fit = false, clip = 0, className = '', id }) {
  const bp = useBp();
  const ref = useRef(null);
  const [room, setRoom] = useState(0);

  useLayoutEffect(() => {
    if (!fit) return undefined;
    const par = ref.current?.parentElement;
    if (!par) return undefined;
    const measure = () => {
      const cs = window.getComputedStyle(par);
      setRoom(par.clientWidth - parseFloat(cs.paddingLeft) - parseFloat(cs.paddingRight));
    };
    measure();
    if (typeof ResizeObserver === 'undefined') return undefined;
    const ro = new ResizeObserver(measure);
    ro.observe(par);
    return () => ro.disconnect();
  }, [fit]);

  let s = (bp === 'm' && scaleM) || (bp !== 'd' && scaleT) || scale;
  if (fit && room > 0) s = Math.min(s, room / 320);
  s = Math.round(s * 1000) / 1000;
  const inv = !!logoUrl && String(card?.bg_color || '').toUpperCase() !== '#FFFFFF';

  return (
    <div
      ref={ref}
      id={id}
      className={`pslot${inv ? ' inv' : ''}${className ? ` ${className}` : ''}`}
      style={{ width: 320 * s, height: (clip || 404) * s, overflow: clip ? 'hidden' : undefined }}
      aria-hidden="true"
    >
      <div className="pin" style={{ transform: `scale(${s})` }}>
        <WalletPass card={card} logoUrl={logoUrl} photoUrl={photoUrl} />
      </div>
    </div>
  );
}
